import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { UserMasterApiService } from 'src/app/services/domain_code/user-master-api.service';
import { MyProfileModel } from 'src/app/models/common/myprofile-model';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth.service';
import { EmbassyService } from 'src/app/services/embassy.service';
@Component({
    selector: 'my-profile',
    templateUrl: './my-profile-copy.component.html',
    styleUrls: ['./my-profile.component.scss']
})
export class MyProfileComponent implements OnInit {
    base_url = environment.baseApiUrl;
    country_url = ApiRoutes.Geo;
    profile_pic_upload_url = `${ApiRoutes.Company}my-profile-pic/`;
    profile_pic;
    current_user: any;
    genderOptions = ['Male', 'Female', 'Other'];

    isProfileEditable = false;
    isCompanyEditable = false;
    profileLoading: boolean = false;
    bannerLoading: boolean = false;
    errorObj: any = {}
    currentDate = new Date(); // Variable to get current date

    upload: boolean = true;
    logo: boolean = false;
    public pics: File[] = [];
    particlesOptions = {
        background: {
            color: {
                value: "#414042",
            },
            position: "inherit !important"
        },
        fpsLimit: 120,
        interactivity: {
            events: {
                // onClick: {
                //     enable: false,
                //     mode: ClickMode.push,
                // },
                // onHover: {
                //     enable: true,
                //     mode: HoverMode.attract,
                //     parallax: {
                //         enable: true,
                //         force: 2,
                //         smooth: 10
                //     }
                // },
                resize: true,
            },
            modes: {
                push: {
                    quantity: 4,
                },
                repulse: {
                    distance: 200,
                    duration: 0.4,
                },
            },
        },
        particles: {
            color: {
                value: "#F05F25",
            },
            links: {
                color: "#F05F25",
                distance: 150,
                enable: true,
                opacity: 0.8,
                width: 1,
            },
            collisions: {
                enable: false,
            },
            move: {
                // direction: MoveDirection.none,
                // enable: true,
                // outModes: {
                //     default: OutMode.bounce,
                // },
                random: false,
                speed: 4,
                straight: false,
            },
            number: {
                density: {
                    enable: true,
                    area: 800,
                },
                value: 80,
            },
            opacity: {
                value: 0.5,
            },
            shape: {
                type: "circle",
            },
            size: {
                value: { min: 1, max: 5 },
            },
        },
        detectRetina: true,
        style: {
            position: "relative",
            width: "100%",
            height: "100%",
            top: "0"
        }
    };
    onFileChange2(event: any) {
        var uFileList: File[] = event.target.pics;
        this.pics = Object.keys(uFileList).map((key: any) => uFileList[key]);
        console.log(this.pics);
        this._snackBar.open("Successfully upload!", 'Close', {
            duration: 2000,
        });
    }
    logoUpload() {
        this.upload = false;
        this.logo = true;
    }
    loadingProfile(val) {
        this.profileLoading = val;
    }

    // async particlesInit(engine: Engine): Promise<void> {
    //     // console.log(engine);

    //     // Starting from 1.19.0 you can add custom presets or shape here, using the current tsParticles instance (main)
    //     // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    //     // starting from v2 you can add only the features you need reducing the bundle size
    //     await loadFull(engine);
    // }
    constructor(
        private _snackBar: MatSnackBar,
        public userService: UserMasterApiService,
        private authService: AuthService,
        public embassyService: EmbassyService,) { }

    myProfileObject: MyProfileModel = {
        role: null,
        designation: null,
        first_name: null,
        last_name: null,
        email: null,
        country: null,
        mobile_number: null,
        whatsapp_number: null,
        gender: null,
        linked_in_profile: null,
        e_sign: null,
        date_of_birth: null,
        anniversary_date: null,
        username: null,
        initials: null,
        profile_role: null,
        company_name: null,
        company_address: null,
        company_website: null,
        company_logo: null,
        picture: null,
        cover_picture: null,
        default_page: null
    }

    ngOnInit(): void {
        this.getMyProfileDetails();
        this.current_user = JSON.parse(localStorage.getItem('current_user'))

        this.profile_pic = this.authService.profile_pic;
        this.authService.profile_pic_changed.subscribe(new_profile_pic => {
            this.profile_pic = new_profile_pic;
        })

    }

    editProfileToggle() {
        this.isProfileEditable = true;
    }
    editProfile() {
        if (this.isProfileEditable == true) {
            this.putMyProfileDetails(this.myProfileObject)
        }
    }

    editCompanyToggle() {
        this.isCompanyEditable = true
    }
    // Toggle only if user is ADMIN
    editCompany() {
        if (this.isCompanyEditable == true) {
            this.putMyProfileDetails(this.myProfileObject)
        }
    }


    getMyProfileDetails() {
        this.userService.getMyProfile().subscribe({
            next: response => {
                this.myProfileObject = { ...response };
                this.myProfileObject.default_page = response.default_page?.id;
            },
            error: error => {
                console.log("error", error)
                return error;
            }
        })
    }

    // Function to catch errors
    catchError(error) {
        if (error.status >= 500) {
            this.errorObj = { ...error.error };
            this._snackBar.open("Something went wrong. Please try again after sometime.", 'Close', {
                verticalPosition: 'top',
                duration: 2000,
            });
            return error;
        } else if (error.status > 399 && error.status < 500) {
            this.errorObj = { ...error.error };
            this._snackBar.open("Profile update failed!!", 'Close', {
                verticalPosition: 'top',
                duration: 2000,
            });
            return error;
        }
    }

    putMyProfileDetails(data) {
        this.userService.updateMyProfile(data).subscribe({
            next: response => {
                this._snackBar.open("Profile updated!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
                this.isProfileEditable = false;
                if (this.current_user.role == 'admin') {
                    this.isCompanyEditable = false;
                }
                this.myProfileObject = { ...response };
                this.myProfileObject.default_page = response.default_page?.id;
                return response;
            },
            error: error => {
                this.isProfileEditable = true
                return this.catchError(error);
            }
        });
    }

    // Upload Profile picture
    uploadDp(event) {
        if (event == null) {
            return;
        }
        if ('id' in event) {
            this.profile_pic = event;
            this.myProfileObject.picture = event;
            this.authService.setProfilePic(event);
        }
    }

    uploadCover(event) {
        if (event == null) {
            return;
        }
        if (event != null) {
            if (this.myProfileObject.cover_picture?.id == event.id) {
                return;
            }
            if (this.myProfileObject.cover_picture?.id != event.id) {
                this.myProfileObject.cover_picture = event.id;
                this.putMyProfileDetails(this.myProfileObject);
            }
        }
    }

    loadingCover(event) {
        if (event) {
            this.bannerLoading = event;
        } else {
            setTimeout(() => {
                this.bannerLoading = event;
            }, 2000);
        }
    }
}
